import React from "react";
import PropTypes from "prop-types";
import Slider from "rc-slider";
import { Colors } from "../../../../shared/config";
import "rc-slider/assets/index.css";

const TemperatureParameter = props => {
  function generateLegend() {
    return (
      <div className="legend-wrap">
        <div className="legend-block blue">
          <span className="legendLabel">-20°</span>
        </div>

        <div className="legend-block blue">
          <span className="legendLabel">-15°</span>
        </div>

        <div className="legend-block red">
          <span className="legendLabel">-10°</span>
        </div>

        <div className="legend-block red">
          <span className="legendLabel">-5°</span>
        </div>

        <div className="legend-block yellow">
          <span className="legendLabel">0°</span>
          <span className="legendLabel right">5°</span>
        </div>

        <div className="legend-block yellow">
          <span className="legendLabel right">10°</span>
        </div>

        <div className="legend-block yellow">
          <span className="legendLabel right">15°</span>
        </div>
      </div>
    );
  }

  function getSliderValue() {
    let value = 3;

    if (props.value >= -20 && props.value <= -15) {
      value = 1;
    } else if (props.value >= -15 && props.value <= -10) {
      value = 2;
    } else if (props.value >= -10 && props.value <= -5) {
      value = 3;
    } else if (props.value >= -5 && props.value <= 0) {
      value = 4;
    } else if (props.value >= 0 && props.value <= 5) {
      value = 5;
    } else if (props.value >= 5 && props.value <= 10) {
      value = 6;
    } else if (props.value >= 10 && props.value <= 15) {
      value = 7;
    }

    return value;
  }

  function mapSliderValue(value) {
    let mappedValue = value;

    switch (value) {
      case 1:
        mappedValue = -18;
        break;
      case 2:
        mappedValue = -13;
        break;
      case 3:
        mappedValue = -8;
        break;
      case 4:
        mappedValue = -3;
        break;
      case 5:
        mappedValue = 2;
        break;
      case 6:
        mappedValue = 7;
        break;
      case 7:
        mappedValue = 13;
        break;
      default:
        mappedValue = -3;
    }

    return mappedValue;
  }

  function onValueChange(value) {
    let val = Math.round(value);

    // console.log("Original value:" + value + ", Rounded Value: " + val);

    if (getSliderValue() === val) return;
    else props.onValueChange(mapSliderValue(val));
  }

  return (
    <div className="parameter-container">
      <div className="wrap">
        <div className="param-header">
          <div className="param-title">{props.title}</div>
          <div className="param-value">°C</div>
        </div>
        <div className="param-content">
          <div className="temperature-slider-wrap">
            <Slider
              min={1}
              max={7}
              value={getSliderValue()}
              onChange={onValueChange}
              trackStyle={{ height: 10, backgroundColor: Colors.GREY_2 }}
              handleStyle={{
                height: 28,
                borderColor: Colors.HWK_RED,
                borderWidth: 6,
                width: 28,
                marginLeft: -14,
                marginTop: -9,
                backgroundColor: Colors.HWK_BLACK
              }}
              railStyle={{ backgroundColor: Colors.GREY_2, height: 10 }}
            />
          </div>
          <div className="fake-slider-track" />
        </div>
        <div className="param-legend">{generateLegend()}</div>
      </div>
    </div>
  );
};

TemperatureParameter.propTypes = {
  value: PropTypes.number,
  onValueChange: PropTypes.func
};

TemperatureParameter.defaultProps = {
  value: 0,
  onValueChange: () => {}
};

export default TemperatureParameter;
